export const strings = {
  SUCCESS_MODIFY: "성공적으로 수정되었습니다.",
  SUCCESS_REGISTER: "성공적으로 등록되었습니다.",
  SUCCESS_REMOVE: "성공적으로 삭제되었습니다.",
};
